module.exports = __webpack_public_path__ + "static/img/camerafor.4328f86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/camerafor.png
// module id = EVGL
// module chunks = 24